import { useBranding } from '../lib/branding.tsx';

export function CompanyExpired() {
  const { branding } = useBranding();
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h1 className="text-lg font-semibold text-slate-900">{branding.companyName ?? 'Compliance'}</h1>
        <p className="mt-2 text-sm text-slate-500">
          Your sign-in link has expired. Please contact your administrator to receive a new
          invitation.
        </p>
        {branding.emailFromAddress && (
          <p className="mt-4 text-sm text-slate-700">
            <a href={`mailto:${branding.emailFromAddress}`} className="text-blue-600 hover:underline">
              {branding.emailFromAddress}
            </a>
          </p>
        )}
      </div>
    </div>
  );
}
